const resetForm = (selector) => {
  if (process.browser)
    setTimeout(() => {
      const form = document.querySelector(selector);
      if (!form) return;
      form.reset();
      const input = document.getElementsByTagName("input")[0];
      if (!input) return;
      input.focus();
      input.blur();
    }, 0);
};

export default resetForm;
